import React from 'react';
import { Route, Switch } from 'react-router-dom';
import UpdateApp from './components/setup/updateApp';
import LandingPage from './components/landingPage';
import NotFoundPage from './components/notfoundPage';
import DevicesPage from './components/devicesPage';
import OrdersPage from './components/ordersPage';
import DeviceTypesPage from './components/devicetypesPage';
import CustomersPage from './components/customersPage';
import Feedback from './components/shared/feedback';
import { appRoles } from './core/security/const';
import { SettingsProvider } from './contexts/settings.context';
import { Pages, Groups } from './models';
import SecuredZone from './libs/security/components/securedZone'; 

import './App.scss';
import { withSecurity } from './libs/security/withSecurity';

const App: React.FC = () => {
  return (
    <div className="app">
      <Switch>
        {/* public pages */}
        <Route exact path="/" component={LandingPage} />
        <Route>
          <SecuredZone>
            <UpdateApp />
            <SettingsProvider>
              <Switch>
                {/* protected pages */}
                <Route exact path="/" component={LandingPage} />
                <Route
                  path={Pages[Groups.DEVICES]}
                  component={withSecurity(DevicesPage)}
                />
                <Route
                  path={Pages[Groups.ORDERS]}
                  component={withSecurity(OrdersPage)}
                />
                <Route
                  path={Pages[Groups.DEVICETYPES]}
                  component={withSecurity(DeviceTypesPage)}
                />
                <Route
                  path={Pages[Groups.CUSTOMERS]}
                  component={withSecurity(CustomersPage, [
                    appRoles.internal,
                  ])}
                />
                <Route component={NotFoundPage} />
              </Switch>
            </SettingsProvider>
          </SecuredZone>
        </Route>
      </Switch>
      <Feedback />
      <div id="modal" />
    </div>
  );
};

export default App;
